__turbopack_context__.v({
  "danger": "index-module__Hwy5nq__danger",
  "dropdownFade": "index-module__Hwy5nq__dropdownFade",
  "dropdownItem": "index-module__Hwy5nq__dropdownItem",
  "dropdownMenu": "index-module__Hwy5nq__dropdownMenu",
  "icon": "index-module__Hwy5nq__icon",
  "profileDropdown": "index-module__Hwy5nq__profileDropdown",
  "profileIcon": "index-module__Hwy5nq__profileIcon",
});
